import DownloadMessage from "../../../../common/DownloadMessage/DownloadMessage";
import Backdrop from "../../../../UI/Backdrop/Backdrop";

import useDownloadCdr from "../../../../../utils/hook/useDownloadCdr";

const CdrDownload = (props) => {
  const fileHash = props?.row?.original?.file?.hash || "-";
  const fileExt = props?.row?.original?.hashIcon?.fileType || "-";
  const severity = props?.row?.original?.severity || "-";
  const tableFileName = props?.row?.original?.file?.name || "-";

  const { downloadOptions, downloadFileName, downloadCdrHandler } = useDownloadCdr(
    `${fileHash}.${fileExt}`,
    tableFileName.replace("CDR_", ""),
  );

  const downloadHandler = (e) => {
    e.stopPropagation();
    downloadCdrHandler();
  };

  return (
    <div onClick={downloadHandler}>
      <button
        className="cdr__table__download-button primary-button"
        disabled={severity !== "not suspicious"}>
        Download
      </button>
      <Backdrop
        show={downloadOptions.downloadStarted}
        message={
          <DownloadMessage
            fileName={downloadFileName}
            loaded={downloadOptions.loaded}
            total={downloadOptions.total}
            progress={downloadOptions.progress}
          />
        }
      />
    </div>
  );
};

export default CdrDownload;
